var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVsdx96 = function SvgVsdx96(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M86 88H26V8h42l18 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M68.001 6H24v84h64V26zM68 9l17 17H68zm18 79H26V8h40v20h20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M52 54v10H42V54zm2-2H40v14h14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3955A3",
    d: "m8 34 40-6v52L8 74z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M73 68c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-2a7 7 0 1 0 0 14 7 7 0 0 0 0-14M63 36c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-2a7 7 0 1 0 0 14 7 7 0 0 0 0-14M74 58H54v2h20z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M74 58h-2v10h2zM64 46h-2v14h2zM33 14a1 1 0 1 0-.001 1.999A1 1 0 0 0 33 14M39 14a1 1 0 1 0-.001 1.999A1 1 0 0 0 39 14M39 20a1 1 0 1 0-.001 1.999A1 1 0 0 0 39 20M45 14a1 1 0 1 0-.001 1.999A1 1 0 0 0 45 14M51 14a1 1 0 1 0-.001 1.999A1 1 0 0 0 51 14M57 14a1 1 0 1 0-.001 1.999A1 1 0 0 0 57 14M79 36a1 1 0 1 0-.001 1.999A1 1 0 0 0 79 36M79 42a1 1 0 1 0-.001 1.999A1 1 0 0 0 79 42M79 48a1 1 0 1 0-.001 1.999A1 1 0 0 0 79 48M79 54a1 1 0 1 0-.001 1.999A1 1 0 0 0 79 54M79 60a1 1 0 1 0-.001 1.999A1 1 0 0 0 79 60M61 78a1 1 0 1 0-.001 1.999A1 1 0 0 0 61 78M55 78a1 1 0 1 0-.001 1.999A1 1 0 0 0 55 78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m39 43-8.062 23h-5.974L17 43h5.68l4.88 16.007q.39 1.3.473 2.294h.097q.114-1.075.506-2.358L33.484 43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vsdx_96_svg__a",
    x1: 17.173,
    x2: 84.979,
    y1: 11.728,
    y2: 92.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    style: {
      stopColor: "#fcfcfc",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    style: {
      stopColor: "#f4f4f4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#e6e6e6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#d1d1d1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    style: {
      stopColor: "#b7b7b7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    style: {
      stopColor: "#444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vsdx_96_svg__a)",
    d: "M88 26 68 6H24v84h64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vsdx_96_svg__b",
    x1: 76,
    x2: 76,
    y1: 33.813,
    y2: 28.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    style: {
      stopColor: "#7f7f7f",
      stopOpacity: 0.0281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#777",
      stopOpacity: 0.045
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#696969",
      stopOpacity: 0.059
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    style: {
      stopColor: "#545454",
      stopOpacity: 0.0713
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    style: {
      stopColor: "#3a3a3a",
      stopOpacity: 0.0826
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 0.0929
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 0.1
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vsdx_96_svg__b)",
    d: "M66 28h20v6H66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vsdx_96_svg__c",
    x1: 62.54,
    x2: 74.472,
    y1: 24.46,
    y2: 12.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2134
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.25
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vsdx_96_svg__c)",
    d: "M24 6v2h42v20h20v28h2V26L68 6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vsdx_96_svg__d",
    x1: 35.508,
    x2: 36.355,
    y1: 85.837,
    y2: 77.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#7e7e7e",
      stopOpacity: 0.0341
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#717171",
      stopOpacity: 0.0694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    style: {
      stopColor: "#5d5d5d",
      stopOpacity: 0.1053
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    style: {
      stopColor: "#404040",
      stopOpacity: 0.1415
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    style: {
      stopColor: "#1b1b1b",
      stopOpacity: 0.1778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    style: {
      stopColor: "#000",
      stopOpacity: 0.2
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vsdx_96_svg__d)",
    d: "M48 86H24v-9.6L48 80z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vsdx_96_svg__e",
    x1: 28,
    x2: 28,
    y1: 78.375,
    y2: 29.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.1546
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.18
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vsdx_96_svg__e)",
    d: "M48 28 8 34v40l40 6z"
  })));
};
export default SvgVsdx96;